import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';

import { PatientApi } from '@core/apis/patient/patient.api';
import { HeaderComponent } from '@core/components/header/header.component';
import { SignInComponent } from '@core/components/sign-in/sign-in.component';
import { SignInDTO } from '@core/dtos/dto';
import { UserTypeEnum } from '@oranta-mis/sdk';
import { ISignIn } from '@core/interfaces/interface';
import { StorageService } from '@core/services/storage.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { PatientNavigationEnum } from '../../navigation.enum';

@Component({
  selector: 'app-patient-sign-in',
  standalone: true,
  imports: [ReactiveFormsModule, SignInComponent, HeaderComponent],
  templateUrl: './patient-sign-in.component.html',
  styleUrl: './patient-sign-in.component.scss',
})
@UntilDestroy()
export class PatientSignInComponent {
  public isLoading: boolean = false;
  public readonly UserTypeEnum = UserTypeEnum;

  constructor(
    private readonly patientApi: PatientApi,
    private readonly router: Router,
    private readonly storageService: StorageService,
  ) {}

  onSubmit(value: ISignIn) {
    this.isLoading = true;
    this.patientApi
      .signIn(value)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: (value: SignInDTO) => {
          localStorage.setItem('token', value.token);
          this.redirect();
        },
        complete: () => {
          this.isLoading = false;
        },
        error: () => {
          this.isLoading = false;
        },
      });
  }

  public onSubmitGoogle(credential: string) {
    this.patientApi
      .google(credential)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: (value) => {
          localStorage.setItem('token', value.token);
          this.router.navigate(['/']);
        },
        error: (err) => {
          throw err;
        },
      });
  }

  public redirect() {
    let choosenPrograms = this.storageService.getChosenPrograms();
    if (choosenPrograms.education?.length || choosenPrograms.service?.length) {
      this.router.navigate([`/${PatientNavigationEnum.basket}`]);
      return;
    }
    this.router.navigate(['/']);
  }
}
